import clsx from 'clsx';
import { FC } from 'react';

export const ConversationMessagesSkeletonSection: FC<{
  widths: { w1: number; w2: number }[];
}> = ({ widths }) => {
  return (
    <div className="grid gap-5">
      {Array.from(widths).map(({ w1, w2 }, i) => (
        <div key={i} className="flex items-center">
          <div className="min-w-12 min-h-12 h-12 w-12 mr-[13px] rounded-full bg-darkMode-gray-medium/[0.28]" />
          <div>
            <div
              className="h-[9px] rounded-full animate-pulse mb-[13px] bg-darkMode-gray-medium/[0.21] w-[100vw-125px]"
              style={{ maxWidth: `${w1}px` }}
            />
            <div
              className="h-[13px] rounded-full animate-pulse bg-darkMode-gray-medium/[0.21] w-[calc(100vw-85px)]"
              style={{ maxWidth: `${w2}px` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

interface ConversationMessagesSkeletonProps {
  className?: string;
}

export const ConversationMessagesSkeleton = ({ className }: ConversationMessagesSkeletonProps) => {
  return (
    <div className={clsx(className, 'grid gap-12 ConversationMessagesSkeleton')}>
      <ConversationMessagesSkeletonSection
        widths={[
          { w1: 150, w2: 480 },
          { w1: 126, w2: 461 },
        ]}
      />
      <ConversationMessagesSkeletonSection
        widths={[
          { w1: 150, w2: 480 },
          { w1: 126, w2: 461 },
          { w1: 150, w2: 480 },
          { w1: 150, w2: 480 },
          { w1: 126, w2: 461 },
          { w1: 174, w2: 533 },
        ]}
      />
      <ConversationMessagesSkeletonSection
        widths={[
          { w1: 150, w2: 480 },
          { w1: 126, w2: 461 },
          { w1: 174, w2: 533 },
        ]}
      />
    </div>
  );
};
